

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: true,
  locales: [{"name":"ru","code":"ru","file":"ru.js"}],
  defaultLocale: "ru",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: true,
  langDir: "../lang/",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"name":"ru","code":"ru","file":"ru.js"}],
  localeCodes: ["ru"],
  additionalMessages: [{"ru":{"astanaEgkn@geoportal":{"toggleLayers":"Развернуть слои","header":"Геоинформационный портал города Астаны","basemapBtn":"Базовая карта"},"astanaEgkn@serviceList":{"header":"Список предоставляемых услуг:"},"astanaEgkn@egkn":{"loginBtn":"Войти в личный кабинет","enter":"Войти в систему","astanaInnovations":"Товарищество с ограниченной ответственностью «Научно-исследовательский проектный институт „Астанагенплан“»","astanaInnovationsadress":"Республика Казахстан, г. Астана, ул. А. Мамбетова 22","writeUs":"Напишите нам:","searchOrg":"Поиск организации по БИНу или наименованию","profile":{"header":"Мой профиль","editBtn":"Изменить персональные данные","changePass":"Сменить пароль","personalInfo":"Персональная информация","passwordSettings":"Настройки пароля","fullname":"ФИО","saveDataBtn":"Сохранить внесенные изменения","savePassBtn":"Сохранить пароль","changePassCheck":"Сменить пароль","currentPass":"Текущий пароль","newPass":"Новый пароль","confirmPass":"Повторите пароль"},"apps":{"searchPlaceholder":"Поиск заявки","headerIncome":"Входящие заявки","header":"Мои заявки","searchBtn":"Искать","status":{"all":"Все заявки","inProcess":"На рассмотрении","done":"Завершено"}},"systemAdminApps":{"currentNode":"Заявка у:","node":"Узел","user":"Пользователь","statusDrafted":"Черновик","searchServicePlaceholder":"Услуга","searchTerrPlaceholder":"Территория","searchAppIdPlaceholder":"Номер заявки","autonode":"Автоузел","noUser":"Не взят в обработку","attachedEmployees":"Прикрепленные сотрудники","noData":"Нет данных","goToMonitor":"Открыть мониторинг","statusRevoked":"Отозвано"}}},"kk":{"astanaEgkn@geoportal":{"toggleLayers":"Қабаттарды кеңейту","header":"Астана қаласының географиялық ақпараттық порталы","basemapBtn":"Негізгі карта"},"astanaEgkn@serviceList":{"header":"Көрсетілетін қызметтердің тізімі:"},"astanaEgkn@egkn":{"loginBtn":"Жеке кабинетке кіру","enter":"Жүйеге кіру","astanaInnovations":"«Астанагенжоспар» ҒЗИ» жауапкершілігі шектеулі серіктестігі","astanaInnovationsadress":"Қазақстан Республикасы, Астана қ., Ә. Мамбетов к-сі, 22","writeUs":"Бізге жазыңыз:","searchOrg":"Ұйымды БСН немесе атауы бойынша іздеу","profile":{"header":"Менің профилім","editBtn":"Жеке деректерді өзгерту","changePass":"Құпия сөзді өзгерту","personalInfo":"Жеке ақпарат","passwordSettings":"Құпия сөз параметрлері","fullname":"Толық аты","saveDataBtn":"Енгізілген өзгерістерді сақтау","savePassBtn":"Құпия сөзді сақтау","changePassCheck":"Құпия сөзді өзгерту","currentPass":"Қазіргі құпия сөз","newPass":"Жаңа Құпиясөз","confirmPass":"Құпия сөзді қайталаңыз"},"apps":{"searchPlaceholder":"Өтінімді іздеу","headerIncome":"Кіріс өтінімдер","header":"Менің өтінімдерім","searchBtn":"Іздеу","status":{"all":"Барлық өтінімдер","inProcess":"Қарауда","done":"Аяқталды"}},"systemAdminApps":{"currentNode":"Өтінім: ________да/де/та/те","node":"Түйін","user":"Пайдаланушы","statusDrafted":"Черновик","searchServicePlaceholder":"Қызмет","searchTerrPlaceholder":"Территория","searchAppIdPlaceholder":"Өтініш нөмірі","autonode":"Автоноды","noUser":"өңделмеген","attachedEmployees":"Бекітілген қызметкерлер","noData":"Мәлімет жоқ","goToMonitor":"Ашық мониторинг","statusRevoked":"Қайтарып алынды"}}}},{"ru":{"new_geoportal@header":{"layers":"Слои","object":"Объект"},"new_geoportal@tabs":{"emptyList":"Список пуст","true":"Да","false":"Нет"}},"kk":{"new_geoportal@header":{"layers":"Слои","object":"Объект"},"new_geoportal@tabs":{"emptyList":"Список пуст","true":"Да","false":"Нет"}}}],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "r",
  3: "u",
  4: ".",
  5: "j",
  6: "s",
  7: "\"",
  8: ":",
  9: "\"",
  10: ".",
  11: ".",
  12: "/",
  13: "l",
  14: "a",
  15: "n",
  16: "g",
  17: "/",
  18: "r",
  19: "u",
  20: ".",
  21: "j",
  22: "s",
  23: "\"",
  24: "}",
}

export const localeMessages = {
  'ru.js': () => import('../../lang/ru.js' /* webpackChunkName: "lang-ru.js" */),
}
